import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tous-devis',
  templateUrl: './tous-devis.component.html',
  styleUrls: ['./tous-devis.component.scss']
})
export class TousDevisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
